import EmptyIcon from '@/assets/images/not-found.svg'

import { Skeleton } from '../ui/skeleton.tsx'

interface Props {
  isFetching: boolean
  text?: string
}

export const EmptyChartData = ({ isFetching, text }: Props) => {
  return isFetching ? (
    <Skeleton className="h-full" />
  ) : (
    <div className="flex flex-col items-center justify-center gap-3 text-center">
      <EmptyIcon />
      <p>{text ? text : 'You do not have any data for this period.'}</p>
    </div>
  )
}
